import React, {useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  TextField,
  Divider, ListItem, ListItemAvatar, IconButton
} from '@mui/material';
import {hasPermissionByPriority} from "../../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../../core/permissions/permissions";
import {useStateContext} from "../../../hooks/useStateContext";
import {FileUploader} from "react-drag-drop-files";
import List from "@mui/material/List";
import Zoom from "react-medium-image-zoom";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import ListItemText from "@mui/material/ListItemText";
import {DeleteRounded} from "@mui/icons-material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (message:any, files:any) => void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
                                                       open,
                                                       onClose,
                                                       onConfirm,
                                                       title = 'Are you sure?',
                                                       description = '',
                                                       confirmText = 'Delete',
                                                       cancelText = 'Cancel',
                                                     }) => {

  const {user} = useStateContext();
  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);
  const [softLoading, setSoftLoading] = useState<boolean>(false);
  const [files, setFiles] = useState<any>([]);
  const [textMessage, setTextMessage] = useState<any>(null);


  const handleChange = (newFiles: any) => {
    const newFilesArray = [...newFiles];
    setFiles((prev: any) => [
      ...prev,
      ...newFilesArray.map((file: any) => {
        file.preview = URL.createObjectURL(file);
        return file;
      }),
    ]);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="caption">{description}</Typography>

        {!isAdmin && (
          <Stack sx={{
            mt: '10px',
            gap: 1
          }}>
            <TextField
              label='Message for approval'
              onChange={(event:any)=>{
              setTextMessage(event.target.value);
            }} />

            <Stack
              sx={{
                opacity: softLoading ? 0.5 : 1,
                pointerEvents: softLoading ? 'none' : 'auto',
              }}
            >
              <FileUploader
                multiple={true}
                handleChange={handleChange}
                name="file"
                classes={'w-full !max-w-[100%] !min-w-[100px]'}
              />
            </Stack>
            <Divider/>
            <List
              component="div"
              aria-labelledby="Files"
              sx={{
                opacity: softLoading ? 0.5 : 1,
                pointerEvents: softLoading ? 'none' : 'auto',
                width: '100%',
              }}
            >
              {files.map((item: any, index: number) => {
                return (
                  <>
                    <ListItem
                      sx={{
                        borderBottom: '1px solid #f3f3f3',
                        padding: '8px',
                      }}
                      key={`list-images-${index}`}
                      id={`list-images-${index}`}
                    >
                      <ListItemAvatar
                        sx={{
                          '& .MuiAvatar-root': {
                            border: '1px solid #e1e1e1',
                            borderRadius: '4px',
                            width: '50px',
                            height: '50px',
                          },
                        }}
                      >
                        {item?.type.includes('image') ? (
                          <Zoom>
                            <Tooltip title={item?.name}>
                              <Avatar src={item?.link} alt={item?.name}/>
                            </Tooltip>
                          </Zoom>
                        ) : (
                          <div
                            className={
                              'w-[50px] h-[50px] rounded-[4px] bg-[#e1e1e1] relative'
                            }
                          >
                            <FolderRoundedIcon
                              sx={{
                                color: '#b9b9b9',
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%,-50%)',
                              }}
                            />
                          </div>
                        )}
                      </ListItemAvatar>
                      <ListItemText
                        secondary={
                          <React.Fragment>
                            <Tooltip title={item?.name}>
                              <Typography
                                variant={'caption'}
                                color={'gray'}
                                sx={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block'
                                }}
                              >
                                {item?.name}
                              </Typography>
                            </Tooltip>
                          </React.Fragment>
                        }
                      />
                      <Stack
                        direction={'row'}
                        sx={{
                          width: '100px',
                        }}
                      >
                        <IconButton
                          onClick={() => {

                          }}
                        >
                          <DeleteRounded color={'error'}/>
                        </IconButton>
                      </Stack>
                    </ListItem>
                  </>
                );
              })}
            </List>

          </Stack>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText}</Button>
        <Button variant="contained" color="primary" onClick={()=> onConfirm(textMessage, files)} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
